import { useCallback, useEffect, useState } from 'react';

export type ThemeChoice = 'light' | 'dark' | 'system';
const THEME_KEY = 'tapete-theme';

function readTheme(): ThemeChoice {
  try {
    const t = localStorage.getItem(THEME_KEY);
    return t === 'light' || t === 'dark' ? t : 'system';
  } catch {
    return 'system';
  }
}

function applyTheme(choice: ThemeChoice) {
  const root = document.documentElement;
  if (choice === 'system') delete root.dataset.theme;
  else root.dataset.theme = choice;
}

/** Tema elegido por el usuario (claro, oscuro o el del sistema), recordado en este navegador. */
export function useTheme() {
  const [theme, setThemeState] = useState<ThemeChoice>(readTheme);
  useEffect(() => applyTheme(theme), [theme]);
  const setTheme = useCallback((choice: ThemeChoice) => {
    setThemeState(choice);
    try {
      if (choice === 'system') localStorage.removeItem(THEME_KEY);
      else localStorage.setItem(THEME_KEY, choice);
    } catch {
      /* sin almacenamiento: solo dura esta visita */
    }
  }, []);
  return { theme, setTheme };
}
